import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ServerMessageController', ServerMessageController);

    /** @ngInject */
    function ServerMessageController(ServerMessageService) {
        const vm = this;

        let counter: number = 0;

        vm.shouldDisplayCloseButton = () => {
            return vm.message.dismissible || counter > 5;
        };

        vm.tryToDismiss = () => {
            counter++;
        };

        vm.close = () => {
            vm.message.displayedNumber++;
            vm.message.lastDismissDate = new Date();

            ServerMessageService.closeMessage(vm.message);
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/server-message/server-message.controller.ts